(() => {
  const script = document.currentScript;
  const apiKey = script?.dataset.posthogKey;
  const apiHost = script?.dataset.posthogHost;
  const methods = ['capture', 'identify'];
  const queue = window.posthog = window.posthog || [];
  queue._i = queue._i || [];
  queue.init = queue.init || ((key, options, name) => queue._i.push([key, options, name || 'posthog']));
  methods.forEach((method) => {
    if (!queue[method]) queue[method] = (...args) => queue.push([method, ...args]);
  });

  window.ProostAnalytics = {
    track: (event, properties = {}) => queue.capture(event, properties),
    identify: (distinctId, properties = {}) => queue.identify(distinctId, properties)
  };

  if (!apiKey || !apiHost) return;

  queue.init(apiKey, {
    api_host: apiHost,
    autocapture: false,
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: false,
    mask_all_text: true,
    mask_all_inputs: true,
    person_profiles: 'identified_only'
  });

  const loader = document.createElement('script');
  loader.async = true;
  loader.src = `${apiHost}/static/array.js`;
  document.head.append(loader);
})();
